module.exports = __webpack_public_path__ + "img/EY__wavespace_sm.0b1adfc1.png";